import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Typography, useTheme, Box, Badge } from "@mui/material";
import NotificationsIcon from "../icons/NotificationsIcon.tsx";
import {
  fetchNotifications,
  notificationsActions,
} from "../../store/notifications.tsx";
import type { RootState } from "../../store/types.tsx";
import { Trans } from "@lingui/react/macro";

interface NotificationsDrawerActionProps {
  closeDrawer: () => void;
}

const NotificationsDrawerAction: React.FC<NotificationsDrawerActionProps> = ({
  closeDrawer,
}) => {
  const dispatch = useDispatch();
  const theme = useTheme();

  const notifications = useSelector((state: RootState) => state.notifications);
  const unreadCount = notifications.allIds.filter(
    (id) => !notifications.byId[id]?.read,
  ).length;

  useEffect(() => {
    dispatch(fetchNotifications() as any);
  }, [dispatch]);

  const handleOpenNotifications = () => {
    closeDrawer();
    dispatch(notificationsActions.setViewing(true));
  };

  return (
    <React.Fragment>
      <Typography
        variant="h4"
        onClick={handleOpenNotifications}
        sx={{
          display: "flex",
          alignItems: "center",
          gap: theme.spacing(1),
          cursor: "pointer",
          whiteSpace: "nowrap",
          fontSize: "1rem !important",
          width: "100%",
          lineHeight: "1",
          margin: "0",
          py: "6px",
          "&:hover": {
            backgroundColor: theme.palette.action.hover,
            borderRadius: "25px",
          },
        }}
      >
        <Box
          sx={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            width: "20px",
            height: "20px",
            marginRight: "1px",
            marginBottom: "5px",
          }}
        >
          <Badge
            badgeContent={unreadCount}
            variant="dot"
            sx={{
              "& .MuiBadge-badge": {
                backgroundColor: "#0041bc",
              },
            }}
          >
            <NotificationsIcon />
          </Badge>
        </Box>
        <Box
          component="span"
          sx={{
            display: "inline-flex",
            alignItems: "left",
          }}
        >
          <Trans context={"Span next to a button serving as a button title"}>
            Notifications
          </Trans>
        </Box>
      </Typography>
    </React.Fragment>
  );
};

export default NotificationsDrawerAction;
